// home-redirect.guard.ts

import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const targetUrl = state.url;
    const role = this.authService.getCurrentRole();

    console.log('Guard → targetUrl:', targetUrl, 'role:', role);

    // ================================
    // 1. Redirect dinamico dalla root
    // ================================
    if (targetUrl === '/' || targetUrl === '') {
      if (role === 'editor') {
        return this.router.parseUrl('/product/list');
      }
      return this.router.parseUrl('/order/list');
    }

    // ==========================================
    // 2. Blocco accesso a /order/... per editor
    // ==========================================
    // Controllo "startsWith" perché ci sono rotte figlie
    if (role === 'editor' && targetUrl.startsWith('/order')) {
      return this.router.parseUrl('/product/list');
    }

    return true;
  }
}
